const baseUrl = process.env.API_BASE_URL;

function getLocalOffset() {
  var date = new Date();
  return date.getTimezoneOffset();
}

export const config = {
  store: null,
  authHeader: () => config.store.getState().auth.authToken,
  tenantHeader: () => config.store.getState().tenant.currentTenant ? config.store.getState().tenant.currentTenant.id : null,
  unauthorizedGetNotifier: () => {},
  unauthorizedPostNotifier: () => {},
  revokeAccessNotifier: (err) => {}
}

function getConfig(override = {}) {
  const clone = Object.assign({}, config);
  const finalConfig = Object.assign(clone, override);
  return finalConfig;
}

export const unauthorizedConfig = {
  authHeader: () => undefined
}

export function fake(result) {
  return new Promise(resolve => {
    setTimeout(() => resolve(result), 400);
  });
}

export function get(url, queryParams, configOverride = {}) {
  if (queryParams) {
    const queryString = Object.keys(queryParams || {})
                              .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
                              .join('&');
    url += `?${queryString}`;
  }
  return apiCall('GET', url, undefined, getConfig(configOverride));
}

export function getStream(url, queryParams, configOverride = {}) {
  if (queryParams) {
    const queryString = Object.keys(queryParams || {})
                              .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
                              .join('&');
    url += `?${queryString}`;
  }
  return apiCall('GET', url, undefined, getConfig(configOverride), 'BLOB');
}

export function post(url, data, configOverride = {}) {
  return apiCall('POST', url, data, getConfig(configOverride));
}

export function put(url, data, configOverride = {}) {
  return apiCall('PUT', url, data, getConfig(configOverride));
}

export function httpPatch(url, data, configOverride = {}) {
  return apiCall('PATCH', url, data, getConfig(configOverride));
}

export function httpDelete(url, configOverride = {}) {
  return apiCall('DELETE', url, undefined, getConfig(configOverride));
}

export function postFormData(url, data) {

  return fetch(`${baseUrl}${url}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': config.authHeader(),
      'Tenant': config.tenantHeader(),
      'Timezone-Offset': getLocalOffset(),
      'EventProviderTypes': 'Cronofy'
    },
    body: data
  })
  .then(res => {
    if (res.ok) {
      console.log(res);
      return res.json().catch(() => null);
    }

    throw res;
  })
  .catch(err => {
    return err.json()
      .then(err => {
        throw (err && err.errorCode && err.errorMessage)
          ? err
          : {
            errorCode: 'api-client',
            errorMessage: 'An unknown error has occurred.'
          }
      });
  });
}

function apiCall(method, url, data, apiConfig, resultType = 'JSON') {
  return fetch(`${baseUrl}${url}`, {
    method,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': apiConfig.authHeader(),
      'Tenant': apiConfig.tenantHeader(),
      'Timezone-Offset': getLocalOffset(),
      'EventProviderTypes': 'Cronofy'
    },
    body: JSON.stringify(data)
  })
  .then(res => {
    if (res.ok) {
      window.res = res;
      switch (resultType){
        case 'BLOB' :
          return res.blob().catch(() => { });
        case 'JSON' :
        default:
          return res.json().catch(() => { });
      }
    }

    throw res;
  })
  .catch(err => {
    return err.json()
      .then(err => {
        if (err && err.errorCode === 'unauthenticated') {
          method === 'GET'
            ? apiConfig.unauthorizedGetNotifier()
            : apiConfig.unauthorizedPostNotifier();
        }
        else if(err && err.errorCode === 'access-revoked-error') {
          apiConfig.revokeAccessNotifier(err);
        }

        throw (err && err.errorCode && err.errorMessage)
          ? err
          : {
            errorCode: 'api-client',
            errorMessage: 'An unknown error has occurred.'
          }
      });
  });
}



// WEBPACK FOOTER //
// src/api/rest-api-calls.js